<template>
    <div class="text-xs-center pa-4" style="max-height: calc(100vh - 100px); overflow: auto">

        <v-dialog v-model="openClubDialog" fullscreen persistent transition="slide-x-reverse-transition"
                  @keydown.esc="cancelClubDialog">
            <v-form v-model="valid" lazy-validation ref="form">

                <v-card class="elc-addmember-card">

                    <div style="height: calc(100vh - 50px);overflow-y: auto;">

                        <v-container grid-list-md>

                            <div style="position:relative;">

                                <h2 class="p-10"> Add Club </h2>
                                <v-tooltip bottom style="position:absolute;top: 0;right: 0;">

                                    <v-btn slot="activator" icon @click="cancelClubDialog">
                                        <v-icon>clear</v-icon>
                                    </v-btn>

                                    <span>Close</span>

                                </v-tooltip>

                            </div>

                            <v-layout wrap>

                                <v-flex xs12 md4 class="p-10" v-if="openClubDialog">
                                    <v-text-field v-model="club.club_name" :rules="nameRules" label="Club Name*"
                                                  id="clubId" autofocus @keypress="isAlphaNumeric"
                                                  required>
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 md4 class="p-10">
                                    <v-select :items="constant.elc_type" v-model="club.elc_type" label="Club Type*"
                                              item-text="value" item-value="id" :rules="fieldRules"></v-select>
                                </v-flex>
                                <v-flex xs12 md4 class="p-10">

                                    <v-text-field v-model="club.elc_code" label="Election Code"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout wrap>

                                <v-flex xs12 md4 class="p-10">
                                    <v-text-field v-model="club.latitude" label="Latitude"
                                                  mask="##.####################"
                                                  return-masked-value
                                                  required></v-text-field>
                                </v-flex>

                                <v-flex xs12 md4 class="p-10">
                                    <v-text-field v-model="club.longitude" label="Longitude"
                                                  mask="##.##################"
                                                  return-masked-value
                                                  required></v-text-field>
                                </v-flex>

                                <v-flex xs12 md4 class="p-10">
                                    <v-text-field v-model="club.booth" label="Booth" required></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap>
                                <v-flex xs12 md4 class="p-10">
                                    <v-autocomplete
                                            v-if="myClubFlag" readonly :items="roleOfficers[0]" :rules="selectRules"
                                            label="Select Nodal Officer*" return-object
                                            item-text="name" v-model="club.officers[0]"
                                            @change="changeMobile"></v-autocomplete>
                                    <v-autocomplete v-else :items="roleOfficers[0]" label="Select Nodal Officer*"
                                                    return-object :rules="selectRules" required
                                                    item-text="name" v-model="club.officers[0]"
                                                    @change="changeMobile"></v-autocomplete>
                                </v-flex>

                                <v-flex xs2 md1 class="p-10">
                                    <v-text-field disabled label="+91"></v-text-field>
                                </v-flex>

                                <v-flex xs10 md4 class="p-10">
                                    <v-text-field v-if="myClubFlag" readonly v-model="club.officers[0].phone"
                                                  :mask="mask" label="Nodal Mobile*" :rules="fieldRules"
                                                  required></v-text-field>
                                    <v-text-field v-else readonly v-model="club.officers[0].phone" :mask="mask"
                                                  label="Nodal Mobile*" :rules="fieldRules"
                                                  required></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3 class="p-10">
                                    <v-select readonly :items="clubStatus" label="Status"
                                              item-text="name" item-value="value" v-model="club.status"
                                    ></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout wrap>
                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field label="Pincode*" v-model="club.pincode" mask="######"
                                                  :rules="pinCodeRules" @input="getArea(club.pincode)"
                                                  required></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="club.area" label="Area"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3 class="p-10">
                                    <!--<v-text-field label="Taluka"-->
                                    <!--v-model="club.taluka" :rules="fieldRules" required></v-text-field>-->
                                    <v-select :items="constant.taluka" label="Taluka*"
                                              v-model="club.taluka" :rules="fieldRules" required></v-select>

                                </v-flex>
                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="club.district" label="District*" :rules="nameRules" required
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 class="p-10 text-sm-right">
                                    <v-btn class="elc-button-radius" @click="cancelClubDialog">Cancel</v-btn>
                                    <v-btn class="elc-button-radius-color" @click="addNewClub"
                                           :disabled="club.club_name==''||club.elc_type===''||club.pincode==''||club.taluka==''||club.district==''
                                           ||club.officers==[]||club.officers[0].phone==''||!valid"
                                    >Save
                                    </v-btn>

                                </v-flex>

                            </v-layout>


                        </v-container>

                    </div>

                </v-card>

            </v-form>
        </v-dialog>

        <alert-modal :alertMsg="msg" :alertMsgDialog="alertDialog" @closeAlert="alertDialog = false"></alert-modal>

    </div>

</template>

<script>
    import Common from '../Common/Constants'
    import AlertModal from '../Common/AlertModal'
    import Vue from 'vue'

    export default {
        name: "AddClub",
        components: {AlertModal},
        props: ['clubDialog', 'editObj', 'editedObj', 'nodalOfficerArr'],
        data() {
            return {
                header: {},
                constant: Common,
                dialog: false,
                alertDialog: false,
                msg: '',
                mask: '##### #####',
                maskAlphaNum: 'NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN',
                tt: '',
                valid: false,
                nameRules: [
                    v => !!v || 'This field is required',
                    (v) => {
                        if (!v || v.length <= 3)
                            return 'Must be greater than 3 characters';
                        else return true;
                    },
                ],
                elecIdRules: [
                    v => !!v || 'Election id is required',
                    (v) => {
                        if (!v || v.length < 10)
                            return 'Must be 10 characters';
                        else if (!v || v.length > 10)
                            return 'Must be 10 characters';
                        else return true;
                    },
                ],
                fieldRules: [
                    v => !!v || 'This field is required',
                ],
                selectRules: [
                    (v) => {
                        if (!v || v.length < 2)
                            return 'This field is required';
                        else return true;
                    }
                ],
                pinCodeRules: [
                    v => !!v || 'This field is required',
                    (v) => {
                        if (!v || v.length >= 1 &&  v.length < 6 )
                            return 'Must be 6 characters';
                        else return true;
                    }
                ],
                club: {
                    status: 1,
                    club_id: '',
                    elc_code: '',
                    elc_type: '',
                    longitude: '',
                    latitude: '',
                    club_name: '',
                    pincode: '',
                    area: '',
                    taluka: '',
                    booth: '',
                    district: 'Arvalli',
                    state: '',
                    officers: [
                        {role: '', name: '', phone: '', officer_id: ''}]
                },
                clubStatus: [
                    {value: 0, name: 'Deactive'},
                    {value: 1, name: 'Active'}
                ],
                elcType: ['Future Voter', 'New Voter', 'Chunav Pathshala', 'Voter Awareness Forum'],
                roleOfficers: [],
                menu: false,
                users: [],
                successToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'success-toast'
                },
                errorToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'error-toast'
                },
                areaData: [],
                pinFlag: false,
                openClubDialog: false,
                user: {},
                myClubFlag: Vue.prototype.$myClubFlag,
            }
        },
        beforeDestroy() {
            console.log("*******beforeDestroy*******", this.editObj)
        },
        destroyed() {
            console.log("*******destroyed*******", this.editObj)
        },

        mounted() {
            let self = this;
            self.user = JSON.parse(localStorage.getItem('user'));
            let token = localStorage.getItem('token');
            if (token === '' || token === undefined || token === null) {
                self.$router.push('/')
            }
            self.header = {
                "Content-Type": "application/json",
                "token": token,
            };
            self.openClubDialog = this.clubDialog;
            self.roleOfficers = this.nodalOfficerArr;
            console.log("self.roleOfficers mounted", self.roleOfficers)

        },
        created() {
            let self = this;
            self.user = JSON.parse(localStorage.getItem('user'));
            let token = localStorage.getItem('token');
            if (token === '' || token === undefined || token === null) {
                self.$router.push('/')
            }
            self.header = {
                "Content-Type": "application/json",
                "token": token,
            };
            self.openClubDialog = this.clubDialog;
            self.roleOfficers = this.nodalOfficerArr;
            if (self.myClubFlag) {
                let a = [];
                a = self.roleOfficers[0]
                self.club.officers = [];
                a.forEach(function (val) {
                    if (val.officer_id == self.user.officer_id) {
                        let obj = {
                            role: 0,
                            name: val.name,
                            phone: val.phone,
                            officer_id: val.officer_id
                        };
                        self.club.officers.push(obj)
                        console.log("self.club.officers", self.club.officers)
                    }
                })
            }
            $('#clubId').focus()
        },
        methods: {
            isAlphaNumeric: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                var ret = (charCode == 32 || (charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122));
                if (!ret) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            getOfficer() {
                let arr = [];
                let self = this;
                let response = [];
                let tempRole = [];
                let a = ['0', '1', '2'];
                a.forEach(function (i) {
                    axios.get(self.constant.apiUrl + 'officer/get/officer/' + i, {headers: self.header})
                        .then(res => {
                            if (res.data.flag) {
                                res.data.data.forEach(function (val) {
                                    val.name = val.prefix + ' ' + val.fname + ' ' + val.mname + ' ' + val.lname;
                                });
                                response = res.data.data;
                                if (response[0].officer_role == 0) {
                                    tempRole[0] = response;
                                }
                                else if (response[0].officer_role == 1) {
                                    tempRole[1] = response;
                                }
                                else if (response[0].officer_role == 2) {
                                    tempRole[2] = response;
                                }
                                self.roleOfficers = tempRole;
                            } else {
                                self.$toasted.show(res.data.message, self.errorToast);
                            }
                        })
                        .catch((handle) => {
                            self.$toasted.show(handle, self.errorToast);
                        })
                });

            },

            /*  getOfficerDetails() {
                  let self = this;
                  let request={
                      "filters": {
                          "search": '',
                      },
                  };
                  axios.post(Common.apiUrl + 'officer/getList', request, {headers: self.header})
                      .then(res => {
                          let officerArr = [];
                          if (res.data.flag) {
                              res.data.data.officers.forEach(function (val) {
                                  val.name =  val.fname + ' ' + val.mname + ' ' + val.lname;
                              });
                              self.roleOfficers[0] = res.data.data.officers;
                              console.log("self.roleOfficers[0]", self.roleOfficers[0])
                              officerArr = self.roleOfficers[0].filter(function (roleOfficerObj) {
                                  return !self.clubDetails.find(function (officerObj) {
                                      return roleOfficerObj.officer_id === officerObj.nodal_officer_id
                                  })
                              });
                              if (officerArr.length != 0) {
                                  self.roleOfficers = [];
                                  self.roleOfficers[0] = officerArr;
                              } else {
                                  self.roleOfficers = [];
                              }
                          }
                          else {
                              self.$toasted.show('Officer Not Found', self.errorToast)
                          }
                      })
                      .catch((handle) => {
                          self.$toasted.show(handle, self.errorToast);
                      })
              },*/
            getArea(data) {
                let self = this;
                if (data.length == 6) {
                    axios.get(self.constant.apiUrl + 'getTerritory/' + data, {headers: self.header})
                        .then(res => {
                            if (res.data.flag) {
                                self.areaData = res.data.data;
                                self.club.area = self.areaData.area;
                                self.club.taluka = self.areaData.taluka;
                                // self.club.district = 'Arvalli';
                                self.pinFlag = true

                            } else {
                                self.club.area = '';
                                self.club.taluka = '';
                            }
                        })
                }
            },
            addNewClub() {
                let self = this;
                let obj = {};
                let new_club_officers = [];
                let club_officers = self.club.officers;
                if (club_officers.length > 1) {
                    club_officers.forEach(function (val) {
                        let size = Object.keys(val).length;
                        if (size == 4) {
                            obj = val;
                            obj.role = 0;
                        }
                    });
                    new_club_officers.push(obj);
                    self.club.officers = new_club_officers
                }
                console.log(self.club)
                if (self.valid) {
                    axios.post(self.constant.apiUrl + 'club/create/', self.club, {headers: self.header})
                        .then(res => {
                            if (res.data.flag) {
                                self.$toasted.show('Club Created Successfully', self.successToast);
                                self.cancelClubDialog();
                                self.$emit('saveClub');

                            } else {
                                self.alertDialog = true;
                                self.msg = '';
                                self.msg = res.data.message;
                                // self.$toasted.show(res.data.message, self.errorToast);
                            }
                        })
                        .catch((handle) => {
                            self.alertDialog = true;
                            self.msg = '';
                            self.msg = "Please fill valid details";
                            // self.$toasted.show(handle, self.errorToast);
                        })
                } else {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = "Please fill valid details";
                }
            },
            cancelClubDialog() {
                let self = this;
                self.openClubDialog = false;
                self.club = {};
                self.dob = null;
                self.$refs.form.reset();
                self.$emit('closeClubDialog');
                // self.$destroy();
            },
            itemText(obj) {
                return obj.fname + ' ' + obj.mname + ' ' + obj.lname
            },
            itemValue(obj) {
                return obj
            },
            changeMobile(val) {
                let a = val.officer_role
                let b = Object({
                    role: val.officer_role,
                    phone: val.phone,
                    officer_id: val.officer_id,
                    name: val.name
                });
                this.club.officers[val.officer_role] = b
                this.$forceUpdate();
            },
            goBack() {
                window.history.go(-1)
                // this.$router.push('/ClubDetails')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Club/AddClub.vue